module.exports = __webpack_public_path__ + "img/rmrAppStoreLogo.a4046204.png";